// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ojuzxxkxlokdhccfjtbf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9qdXp4eGt4bG9rZGhjY2ZqdGJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1MTY3NzksImV4cCI6MjA1OTA5Mjc3OX0.QYN314QjHz5FbznQ2Ay0F6NEibdCBkuRK4oniYSrDuE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);